/* eslint-disable */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useModal } from '../../hooks/use-modal-store'
import { removeToken } from '../../utils/AuthUtil'
import PostHogTracker from '../../utils/PostHogTracker'
import FullPagePopupLayout from './FullPagePopupLayout'

const KycPhoneUpdate = ({ data }) => {
  if (!data?.isKycPhUpdate) return null

  return (
    <div className='fabits-kyc-status-note'>
      <p>Your login number was updated.</p>
      <span>{data?.kycPhoneNumber}</span>
      <p>Use this number to log in going forward.</p>
    </div>
  )
}

const KycPopups = () => {
  const { isOpen, onClose, type, data } = useModal()
  const [showLearnMore, setShowLearnMore] = useState(false)
  const { severity, title, message, handleRedirect } = data
  const navigate = useNavigate()
  const isModalOpen = isOpen && type === 'openKycPopup'

  const handleLogout = () => {
    PostHogTracker.logout('KYC Popup')
    PostHogTracker.reset()
    removeToken()
    navigate('/login')
  }

  const handleContinue = () => {
    onClose(), handleRedirect()
  }

  const messageText = data?.isKycPhUpdate
    ? 'Your login number has changed. Save the updated number before you continue.'
    : message
  const fallbackTitle =
    severity === 'failure'
      ? 'Please try again'
      : severity === 'auto_declined'
      ? 'KYC declined'
      : severity === 'needs_review'
      ? 'KYC under review'
      : severity === 'cvl_kra_pending'
      ? 'One last step'
      : 'KYC update'
  const displayTitle = title || fallbackTitle

  return (
    <>
      {severity === 'auto_approved' && (
        <FullPagePopupLayout
          isOpen={isModalOpen}
          onClose={onClose}
          severity={severity}
          title={displayTitle}
          message={messageText}
          actionsClassName='fabits-global-popup-actions-single'
          actions={
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={handleLogout}
            >
              Logout
            </button>
          }
        >
          {data?.isKycPhUpdate && <KycPhoneUpdate data={data} />}
        </FullPagePopupLayout>
      )}

      {severity === 'nominee_confirmation' && (
        <FullPagePopupLayout
          isOpen={isModalOpen}
          onClose={handleLogout}
          severity={severity}
          title={displayTitle}
          message={messageText}
          actionsClassName='fabits-global-popup-actions-single'
          actions={
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={handleLogout}
            >
              Logout
            </button>
          }
        >
          <KycPhoneUpdate data={data} />
          <div className='fabits-kyc-status-note'>
            <p>Quick tip</p>
            <p>
              Search for <span>BSE STAR</span> or <span>nomination authentication</span> in your
              inbox.
            </p>
          </div>
        </FullPagePopupLayout>
      )}

      {severity === 'cvl_kra_pending' && (
        <FullPagePopupLayout
          isOpen={isModalOpen}
          onClose={handleLogout}
          severity={severity}
          title={showLearnMore ? 'Why is this required?' : displayTitle}
          message={
            showLearnMore
              ? 'Your details in the Central KYC Registry database need to be validated or updated. This regulatory step keeps your account secure, compliant, and fully authenticated.'
              : messageText
          }
          actions={
            <>
              <button
                type='button'
                className='fabits-global-popup-button fabits-global-popup-button-secondary'
                onClick={handleLogout}
              >
                Logout
              </button>
              <button
                type='button'
                className='fabits-global-popup-button fabits-global-popup-button-primary'
                onClick={() => setShowLearnMore((prev) => !prev)}
              >
                {showLearnMore ? 'Show less' : 'Learn more'}
              </button>
            </>
          }
        >
          {!showLearnMore && (
            <>
              <KycPhoneUpdate data={data} />
              <div className='fabits-kyc-status-note'>
                <p>Your Relationship Manager will contact you shortly to assist you.</p>
              </div>
            </>
          )}
        </FullPagePopupLayout>
      )}

      {['auto_declined', 'user_cancelled', 'needs_review', 'failure'].includes(severity) && (
        <FullPagePopupLayout
          isOpen={isModalOpen}
          onClose={onClose}
          severity={severity}
          title={displayTitle}
          message={message}
          actionsClassName='fabits-global-popup-actions-single'
          actions={
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={handleContinue}
            >
              {severity !== 'needs_review' ? 'Retry KYC' : 'Back to home'}
            </button>
          }
        />
      )}
    </>
  )
}

export default KycPopups
